import { createLocalSessionAdapter } from "../localSessionAdapter";
import { readTranscript } from "./transcriptStore";

/**
 * Kaltura session data adapter. Kaltura exposes no session or transcript API
 * and the conversation is generated by us, so the local buffer is already
 * complete at end of session — see `createLocalSessionAdapter`.
 */
export const kalturaSessionAdapter = createLocalSessionAdapter({
  readTranscript,
  source: "kaltura-local",
});
